import type { PropsWithChildren } from "react";

import { LandingThemeScope } from "components/landing/theme/LandingThemeScope";

export default function LandingLayout({ children }: PropsWithChildren) {
  return <LandingThemeScope>{children}</LandingThemeScope>;
}
